import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export default class CreateVHostForm {
  public systemUserId: number;
  public websiteId: number;
  public server: string;

  public rules: { [name: string]: FormValidationFunction[] } = {
    systemUserId: [
      (v: number) => !!v || v <= 0 || 'SystemUserId field is required',
    ],
    websiteId: [
      (v: number) => !!v || v <= 0 || 'WebsiteId field is required',
    ],
    server: [
      (v: string) => !!v || 'Server field is required',
    ],
  };
}
